import React, { Component } from "react"
import { Row, Col } from "reactstrap"
import {ToastContainer} from "react-toastify";

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <ToastContainer />
        <footer className="footer">
          <div className="container-fluid">
            <Row>
              <Col sm={6}>{new Date().getFullYear()} © KTL</Col>
              <Col sm={6}>
                <div className="text-sm-end d-none d-sm-block">
                Design & Develop by nftsoft.com
              </div>
              </Col>
            </Row>
          </div>
        </footer>
      </React.Fragment>
    )
  }
}

export default Footer;
